import React, { ReactElement } from 'react';
import { Rate as RateBase, RateProps } from 'antd';
import classNames from 'classnames';
import styles from './index.module.scss';

interface IRateProps extends RateProps {
  text?: ReactElement | string;
  describe?: ReactElement | null | undefined;
  rateDetail?: { label: string; value: string | number }[];
}

export default function Rate(props?: IRateProps) {
  // const [valueRate, setValueRate] = useState(props?.value || props?.defaultValue);
  return (
    <div className={classNames(styles.rate)}>
      <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.ratePoint)}>
        <RateBase
          {...props}
          onChange={value => {
            // setValueRate(value);
            props?.onChange?.(value);
          }}
        />
        {props?.disabled ? (
          props?.describe
        ) : props?.value ? (
          <span className={styles.ratePoint}>（{props?.value}分）</span>
        ) : (
          ''
        )}
      </div>
      {props?.rateDetail && props?.rateDetail.length > 0 && (
        <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.rateDetail)}>
          {props?.rateDetail?.map((item, index) => (
            <div className={styles.rateDetail__text} key={index}>
              {item.label}：{item.value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
